<template>
  <div class="aftersaleNav">
    <el-submenu index="2">
      <template slot="title">
        <i class="iconfont icon-shouhouguanli"></i>
        <span>{{ptitle}}</span>
      </template>
      <el-menu-item
        v-for="(item,i) in menuList"
        :key="i"
        :index="item.index"
        @click="rediret(item)"
      >
        <span slot="title">{{item.title}}</span>
      </el-menu-item>
    </el-submenu>
  </div>
</template>
<script>
export default {
  data () {
    return {
      ptitle: '售后管理',
      menuList: [
        {
          index: '2-1',
          title: '售后单',
          url: '/afterSale/manage'
        }
      ]
    }
  },
  created () {
    this.getCurrentIndex(this.$route.path)
  },
  methods: {
    getCurrentIndex (path) {
      if (path.search('aftersale') !== -1) {
        let selectItem = this.menuList.filter(item => item.url === path)
        this.rediret(selectItem[0])
      }
    },
    rediret (item) {
      this.$emit('rediret', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/leftnav/aftersaleNav.vue